import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Horaires.css';
import '../styles/AppAgt.css';
import '../styles/PresentationHomogene.css';
import ProchainHoraire from '../components/ProchainHoraire';
import Footer from '../components/Footer';

const Horaires = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/contact');
        window.scrollTo(0, 0);
    };
    return (
        <div className='AppAgt'>
            {/* Titre simple sous le header */}
            <div className='horaires-header-simple'>
                <h1 className='horaires-main-title'>Horaires & Informations</h1>
                <h2 className='horaires-museum-title'>Musée de la Gare de Trôo</h2>
                <p className='horaires-main-description'>
                    Découvrez nos horaires d'ouverture et planifiez votre visite dans notre musée ferroviaire
                </p>
            </div>

            {/* Section principale avec style de l'accueil */}
            <div className='Presentation'>
                {/* Horaires principaux */}
                <div className='presentation-section'>
                    <div className='presentation-card horaires-highlight'>
                        <div className='section-header horaires-header'>
                            <h2 className='section-title'>🚂 Horaires d'Ouverture</h2>
                        </div>
                        <ProchainHoraire />
                        <div className='section-content'>
                            <div className='horaires-grid-main'>
                                <div className='horaire-item primary'>
                                    <div className='horaire-icon'>📅</div>
                                    <div className='horaire-info'>
                                        <h3>Mercredis après-midi</h3>
                                        <div className='horaire-time'>14H30 - 17H00</div>
                                        <p className='horaire-desc'>Visite du musée et Ateliers modélisme au 2ème étage</p>
                                    </div>
                                </div>
                                
                                <div className='horaire-item summer'>
                                    <div className='horaire-icon'>☀️</div>
                                    <div className='horaire-info'>
                                        <h3>Journées du Patrimoine (20 et 21 Septembre 2025)</h3>
                                        <div className='horaire-time'>10H00 - 17H00</div>
                                        <p className='horaire-desc'>Ouverture exceptionnelle Samedi et Dimanche</p>
                                    </div>
                                </div>
                                
                                <div className='horaire-item train'>
                                    <div className='horaire-icon'>🚆</div>
                                    <div className='horaire-info'>
                                        <h3>Passages du Train TTVL</h3>
                                        <div className='horaire-time'>Selon horaires</div>
                                        <p className='horaire-desc'>Ouverture lors des passages.</p>
                                    </div>
                                </div>
                                
                                <div className='horaire-item group'>
                                    <div className='horaire-icon'>👥</div>
                                    <div className='horaire-info'>
                                        <h3>Visites de Groupes</h3>
                                        <div className='horaire-time'>Sur rendez-vous</div>
                                        <button className='horaires-cta' onClick={handleContactClick}>
                                            Nous Contacter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section Tarifs */}
                <div className='presentation-section'>
                    <div className='presentation-card tarif-card'>
                        <div className='section-header tarif-header'>
                            <h2 className='section-title'>💰 Tarifs d'Entrée</h2>
                        </div>
                        <div className='section-content'>
                            <div className='tarifs-display'>
                                <div className='tarif-item-large adulte'>
                                    <div className='tarif-icon-large'>🎫</div>
                                    <div className='tarif-amount'>2€</div>
                                    <div className='tarif-label'>Adultes</div>
                                </div>
                                <div className='tarif-separator'>|</div>
                                <div className='tarif-item-large adulte'>
                                    <div className='tarif-icon-large'>❤️</div>
                                    <div className='tarif-amount'>2€</div>
                                    <div className='tarif-label'>Carte Avantage Adultes</div>
                                    <div className='tarif-label2'>La carte vous est remise à la gare et vous permettra de bénéficier d'un tarif réduit pour visiter la grotte pétrifiante et la cave Yucca à Trôo</div>
                                </div>
                                <div className='tarif-separator'>|</div>
                                <div className='tarif-item-large enfant'>
                                    <div className='tarif-icon-large'>👶</div>
                                    <div className='tarif-amount gratuit'>Gratuit</div>
                                    <div className='tarif-label'>Enfants -10 ans accompagnés</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Horaires;
